import * as types from './types'
import { getQueryString, post, get } from '../util'

/***          common              ***/
/**
 * [修改加载状态]
 * @param  {[type]} commit
 * @param  {[type]} status 【加载状态]
 * @return
 */
export const changeLoadingStatus = ({ commit }, status) => {
    commit(types.UPDATE_LOADING, status)
}

/**
 * [修改页面切换]
 * @param  {[type]} commit
 * @param  {[type]} direction [页面切换]
 * @return
 */
export const changeDirection = ({ commit }, direction) => {
    commit(types.UPDATE_DIRECTION, direction)
}

/**
 * [修改当前底部tab页]
 * @param  {[type]} commit
 * @param  {[type]} curTab    [修改当前底部tab页]
 * @return
 */
export const changeCurTab = ({ commit }, curTab) => {
    commit(types.CHANGE_CUR_TAB, curTab)
}

/**
 * 获取用户信息
 */
export const getUserInfo = ({ commit }) => {
    let token = process.env.NODE_ENV == 'production'
                ? localStorage.getItem('RS-TOKEN')
                : '6:deefb29f-fe58-5903-f9b0-66314ccd2463'

    if (token === null) {
        let code    = getQueryString('code'),
            _state  = getQueryString('state'),
            action  = getQueryString('action')

        if (_state == 'wechat_oauth_callback') {
            if (action == 'bind-user') {
                commit(types.BIND_USER)
            } else {
                // 授权返回
                post('v1/member/weixin_oauth_check', {
                    code: code
                }, function(rsp) {
                    let res = rsp.body

                    if (res.code == '10000' && typeof res.data.openid != 'undefined') {
                        // 暂存数据
                        localStorage.setItem('avatar',      res.data.headimgurl)
                        localStorage.setItem('nickname',    res.data.nickname)
                        localStorage.setItem('open_id',     res.data.openid)
                        localStorage.setItem('union_id',    res.data.unionid)

                        location.href = '/m/?state=wechat_oauth_callback&action=bind-user#/'
                    } else if (typeof res.data.token != 'undefined') {
                        localStorage.setItem('RS-TOKEN',    res.data.token)
                        commit(types.CHANGE_LOGIN_INFO,     res.data.token)

                        window.location.href = '/m/?#/'
                    } else {
                        window.location.href = '/m/?#/'
                    }
                })
            }
        } else {
            localStorage.removeItem('RS-TOKEN')

            localStorage.setItem('refHref', location.href)

            // 获取微信授权地址
            get('v1/member/weixin_oauth_url', {}, function(rsp) {
                if (rsp.body.code == '10000') {
                    location.href = rsp.body.data.url
                } else {
                    location.href = '/m/?#/'
                }
            })
        }
    } else {
        commit(types.CHANGE_LOGIN_INFO, token)
        // 检测用户Token合法性
        let _this = this
        // 请求接口
        get('v1/member/info', {}, function(rsp) {
          let res = rsp.body
          if (rsp.body.code != 10000) {
              localStorage.removeItem('RS-TOKEN')

              localStorage.setItem('refHref', location.href)

              // 获取微信授权地址-重新授权
              get('v1/member/weixin_oauth_url', {}, function(rsp) {
                  if (rsp.body.code == '10000') {
                      location.href = rsp.body.data.url
                  } else {
                      location.href = '/m/?#/'
                  }
              })
          } else {
              localStorage.setItem('RS-TOKEN', token)
          }
        })
    }
}

/**
 * 更新购物车列表
 */
export const updateCarts = ({ commit }) => {
    get('v1/cart/lists', {}, function(rsp) {
      let res = rsp.body
      if (res.code == 10000) {
        commit(types.INIT_CARTS, res.data)
      }
    })
}

/**
 * re_alert 动作
 */
export const alertAction = ({ commit }, params) => {
    commit(types.CHANGE_ALERT_TITLE, params)

    setTimeout(() => {
        params.title = ''
        params.status = false

        commit(types.CHANGE_ALERT_TITLE, params)
    }, 1000)
}


/**
 * rs_confirm 动作
 */
 export const confirmAction = ({ commit }, params) => {
     commit(types.UPDATE_CONFIRM_CONTENT, params)
 }



// WEBPACK FOOTER //
// ./src/vuex/actions.js